import { themeTextColorMap } from '@mntn-dev/ui-theme'

import type { SvgIconProps } from './types/props.ts'

export const DotIcon = (props: SvgIconProps) => {
  const { color } = props
  return (
    <svg
      {...props}
      width="6"
      height="6"
      viewBox="0 0 6 6"
      aria-hidden="true"
      role="img"
      className={`h-1 w-1 ${color ? themeTextColorMap[color] : null}  fill-current`}
    >
      <circle cx={3} cy={3} r={3} />
    </svg>
  )
}
